import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Custom Blood Pressure icon: Sphygmomanometer with dial and pump bulb.
 * Matches the exact design from the reference image.
 */
const BloodPressureSvgIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon viewBox="0 0 64 64" {...props}>
    <g fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      {/* Tube connecting dial and bulb */}
      <path d="M 22 42 L 22 52 C 22 62, 46 62, 46 52 L 46 44" />
      
      {/* Dial - Outer Circle */}
      <circle cx="22" cy="22" r="12" />
      
      {/* Dial - Inner Circle */}
      <circle cx="22" cy="22" r="8" />
      
      {/* Dial - Base/Connector */}
      <path d="M 18 34 L 26 34 L 26 38 L 18 38 Z" fill="currentColor" stroke="none" />
      <path d="M 20 38 L 24 38 L 24 42 L 20 42 Z" fill="currentColor" stroke="none" />

      {/* Dial - Needle */}
      <circle cx="22" cy="22" r="1.5" fill="currentColor" stroke="none" />
      <line x1="22" y1="22" x2="26" y2="16" />

      {/* Dial - Ticks on inner circle (top-left) */}
      <line x1="17" y1="22" x2="19" y2="22" />
      <line x1="18.5" y1="18.5" x2="20" y2="20" />
      <line x1="22" y1="17" x2="22" y2="19" />

      {/* Bulb - Main body */}
      <ellipse cx="46" cy="28" rx="7" ry="14" />

      {/* Bulb - Top Tip */}
      <path d="M 44 14 L 48 14 L 48 10 L 44 10 Z" fill="currentColor" stroke="none" />
      
      {/* Bulb - Bottom Base */}
      <path d="M 44 42 L 48 42 L 48 46 L 44 46 Z" fill="currentColor" stroke="none" />

      {/* Bulb - Horizontal lines on left side */}
      <line x1="36" y1="22" x2="40" y2="22" />
      <line x1="35" y1="28" x2="40" y2="28" />
      <line x1="36" y1="34" x2="40" y2="34" />
    </g>
  </SvgIcon>
);

export default BloodPressureSvgIcon;
